/**
 * @author don
 * This file is specifically used to store any utils for the antd Tree/TreeSelect component
 */

// TODO: SW-2841 Consider moving to the backend
export const deepMapTree = (tree) => {
  const mappedTree = tree.map((tag) => {
    return {
      ...tag,
      value: tag.key,
      ...(tag.children && { children: deepMapTree(tag.children) }),
    };
  });

  return mappedTree;
};
